import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const stories = [{
  medal: '🥇',
  quote: 'Le mostré una receta a mi pediatra y me preguntó dónde la había conseguido. Le conté y me dijo que siguiera así porque los números de hierro de mi hija habían mejorado. Eso me lo dice todo.',
  name: 'Rocío',
  desc: 'Mamá de Emilia, 2 años · 🇦🇷 Argentina',
  accent: 'border-l-[#FFB300]'
}, {
  medal: '🥈',
  quote: 'Hubo un momento en que me senté y lloré porque no sabía qué más hacer. Sentía que fallaba como mamá porque mi hijo no comía y yo me quedaba sin ideas. NutriPeques me devolvió la confianza en la mesa.',
  name: 'Natalia',
  desc: 'Mamá de Thiago, 3 años · 🇪🇸 España',
  accent: 'border-l-[#9E9E9E]'
}, {
  medal: '🥉',
  quote: 'Mi hija solo quería galletitas, jugos, todo de paquete. Yo ya había resignado. Pensé que era así y listo. Hoy come cosas que antes ni miraba. Sin pelea. Sin llanto. Sin que yo tenga que rogar.',
  name: 'Tatiana',
  desc: 'Mamá de Sofía, 3 años · 🇺🇸 USA',
  accent: 'border-l-[#CD7F32]'
}];
export function CommunityStories() {
  return <section className="py-16 px-4 bg-[#FFF8F0]" data-id="element-91" data-mp="x1oplglfkahc">
      <div className="max-w-lg md:max-w-3xl mx-auto" data-id="element-92" data-mp="x03xryqi35n6">
        <div className="flex items-center justify-center gap-2 mb-8" data-id="element-93" data-mp="120i5ffo6wdko">
          <Star className="w-5 h-5 fill-[#FFB300] text-[#FFB300] shrink-0" data-id="element-94" data-mp="16rzzrkvpjfwo" />
          <h2 className="text-xl md:text-2xl font-black text-gray-900 tracking-wide text-center leading-snug" data-id="element-95" data-mp="16u2z4vir2le2">
            Historias de mamás con las mismas preguntas que vos, que agradecen
            formar parte de la comunidad
          </h2>
          <Star className="w-5 h-5 fill-[#FFB300] text-[#FFB300] shrink-0" data-id="element-96" data-mp="1kt2l1vevom6j" />
        </div>

        <div className="space-y-4" data-id="element-97" data-mp="1prdx8csnb8rx">
          {stories.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-[#FFE0B2] border-l-4 ${t.accent} relative`} data-id="element-98" data-mp="1porle0yq273w" data-mpi={idx}>
              <span className="absolute -top-2 -left-2 text-2xl drop-shadow-sm select-none" data-id="element-99" data-mp="3tgicu0cctnjf">
                {t.medal}
              </span>
              <div className="flex gap-0.5 mb-2" data-id="element-100" data-mp="3ofb521a7oocr">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#FFB300] text-[#FFB300]" data-id="element-101" data-mp="69ydh2yesnbe" data-mpi={i} />)}
              </div>
              <p className="text-gray-700 text-sm md:text-base italic mb-3 leading-relaxed" data-id="element-102" data-mp="28w8s6lq3j21">
                "{t.quote}"
              </p>
              <p className="text-xs md:text-sm text-gray-600" data-id="element-103" data-mp="g2x56tp7ctz8">
                <span className="font-bold text-gray-900" data-id="element-104" data-mp="b2j5q01o2sct">{t.name}</span>
                <span className="text-gray-400" data-id="element-105" data-mp="pygyr9gangkt"> — </span>
                {t.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}